import React from "react";

import SignaturePad from "../../../lib/signature_pad";
import RegistrationCard from "../RegistrationCard";
import { Button, CardActions } from "react-md";

/*
 Signature step using signature_pad library.
 https://github.com/szimek/signature_pad#api
 */
export default class SignatureStep extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isUserSigning: false
    };

    this.checkUserSigning = this.checkUserSigning.bind(this);
    this.reset = this.reset.bind(this);
  }

  componentDidMount() {
    const signatureCanvas = document.querySelector("canvas#signatureCanvas");
    this.signaturePad = new SignaturePad(signatureCanvas);
    this.signaturePad.onEnd = this.checkUserSigning;

    const { currentRegistration } = this.props;
    if (currentRegistration && currentRegistration.signature) {
      this.signaturePad.fromDataURL(currentRegistration.signature);
      this.checkUserSigning();
    }
  }

  componentWillUnmount() {
    this.signaturePad.onEnd = null;
    this.signaturePad.off();
  }

  reset() {
    this.signaturePad.clear();
    this.checkUserSigning();
  }

  checkUserSigning() {
    this.setState(() => {
      if (this.signaturePad) {
        return {
          isUserSigning: !this.signaturePad.isEmpty()
        }
      }
    });
  }

  render() {
    return (
      <RegistrationCard
        title="Signature"
        subtitle="Please sign using your fingertip below."
      >
        <section className="md-grid">
          <div
            className="md-cell md-cell--12"
            style={{ textAlign: "center", border: "1px solid #f1f1f1" }}
          >
            <canvas id="signatureCanvas" width="600" height="300" />
          </div>

        </section>
        <CardActions>
          <Button
            raised
            label="Reset"
            secondary
            className="md-cell--left"
            onClick={() => this.reset()}
          />
          <Button
            disabled={!this.state.isUserSigning}
            raised
            label="Save & Continue"
            primary
            className="md-cell--right"
            onClick={() =>
              this.props.onSubmit({
                signature: this.signaturePad.toDataURL(),
                nextStep: "complete"
              })}
          />
        </CardActions>
      </RegistrationCard>
    );
  }
}

SignatureStep.propTypes = {};
SignatureStep.defaultProps = {};



// WEBPACK FOOTER //
// ./src/registration/components/Signature/SignaturePage.jsx